import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { SignUpComponent } from './sign-up/sign-up.component';
import { LoginScreenComponent } from './login-screen/login-screen.component';
import { RegistrationScreenComponent } from './registration-screen/registration-screen.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { VerifyForgotPasswordComponent } from './verify-forgot-password/verify-forgot-password.component'
import { SetPasswordComponent } from './set-password/set-password.component'
import { LoginGuard } from '../guards/login.guard';
// import { SignInComponent } from './sign/sign-in.component';
import { EventFormSubmissionComponent } from '../features/home/events/event-form-submission/event-form-submission.component'
import { FeedbackSubmissionComponent } from '../features/home/events/event-feedback/feedback-submission/feedback-submission.component';
import { RsvpUnavailabityConfirmComponent } from '../features/home/events/rsvp-unavailabity-confirm/rsvp-unavailabity-confirm.component';
const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
//   {
//     path: '**',
//     redirectTo: 'login',
//     pathMatch: 'full'
//   },
  {
    path: 'login',
    canActivate: [LoginGuard],
    component: LoginScreenComponent
  },
  {

    // tslint:disable-next-line:max-line-length
    path: 'register/:token',

    component: RegistrationScreenComponent
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordComponent
  },
  {
    path: 'verify-forgot-password',
    component: VerifyForgotPasswordComponent
  },
  {
    path: 'set-password',
    component: SetPasswordComponent
  },
  {
    path:"details/:id",
    component: EventFormSubmissionComponent
  },
  {
    path:"event-feedback/:id/:rsvpid",
    component: FeedbackSubmissionComponent
  },
  {
    path:"unavailability-confirmation/:event_id/:user_id",
    component: RsvpUnavailabityConfirmComponent
  },
//   {
//     path: 'signIn',
//     canActivate: [SignInAuthGuard],
//     component: SignInComponent
//   },
//   {
//     path: '**',
//     redirectTo: 'signUp',
//     pathMatch: 'full'
//   }


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
